import { Entity, CSGetEntity } from '@admiin-com/ds-graphql';
import React from 'react';
import { useSelectedEntity } from '../../../../../../../../hooks/useSelectedEntity/useSelectedEntity';
import { useEntitySelect } from '../../../../../../../hooks/useEntitySelect/useEntitySelect';
import { useNonAccountEntities } from '../../../../../../../../hooks/useUserEntities/useUserEntities';
import { useRecentClients } from '../../../../../../../hooks/useRecentClients/useRecentClients';
import { useFirmId } from '../../../../../../../../hooks/useClientWorkflow/useClientWorkflow';
import { useClients } from '../../../../../../../../hooks/useClients/useClients';
import { gql, useApolloClient } from '@apollo/client';

export function useSearchResults({
  query,
}: // limit = 5,
{
  query: string;
  limit?: number;
}) {
  const { entities: normalEntities, loading: normalLoading } =
    useNonAccountEntities({
      searchName: query,
    });
  const { clients, loading: searchedLoading } = useClients({
    searchName: query,
    limit: 5,
  });

  const { firmId } = useFirmId();
  const hasClients = !!firmId;

  const { recentClients, loading: recentLoading } = useRecentClients();

  const onEntityChange = useEntitySelect();

  const { options, loading } = React.useMemo<{
    options: Entity[];
    loading: boolean;
  }>(() => {
    if (!hasClients) return { options: normalEntities, loading: normalLoading };
    if (!query && recentClients.length > 0)
      return { options: recentClients, loading: recentLoading };
    return { options: clients, loading: searchedLoading };
  }, [
    hasClients,
    normalEntities,
    query,
    recentClients,
    clients,
    normalLoading,
    recentLoading,
    searchedLoading,
  ]);

  const { entity: value } = useSelectedEntity();

  const selectedEntity = React.useMemo<Entity | null>(() => {
    if (!value) return null;
    if (hasClients) return null;
    return {
      ...value,
    };
  }, [value, hasClients]);
  const apolloClient = useApolloClient();

  const onChange = (_: any, newValue: Entity | null) => {
    if (newValue) {
      apolloClient.writeQuery({
        query: gql(CSGetEntity),
        data: {
          getEntity: newValue,
        },
        variables: {
          id: newValue.id,
        },
      });
      onEntityChange(newValue.id);
    }
  };

  return {
    options,
    value: selectedEntity,
    loading,
    onChange,
  };
}
